import { render, staticRenderFns } from "./AutocompleteSuggestion.vue?vue&type=template&id=f787a712&scoped=true"
import script from "./AutocompleteSuggestion.vue?vue&type=script&lang=ts"
export * from "./AutocompleteSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./AutocompleteSuggestion.vue?vue&type=style&index=0&id=f787a712&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f787a712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f787a712')) {
      api.createRecord('f787a712', component.options)
    } else {
      api.reload('f787a712', component.options)
    }
    module.hot.accept("./AutocompleteSuggestion.vue?vue&type=template&id=f787a712&scoped=true", function () {
      api.rerender('f787a712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/AutocompleteSuggestion.vue"
export default component.exports